export const PropsType = {
    list:{
        type:Array,
        default:() => []
    },
    level:{
        type:Number,
        default:() => []
    },
    callBack: {
        type:Object,
        default:() => ({})
    },
    selected:{
        type: Number,
        default:() => undefined
    },
    addNewOne: {
        type: Function,
        default: () => () => {}
    },
    editOne: {
        type: Function,
        default: () => () => {}
    },
    parent: {
        type:Object,
        default:() => ({})
    },
    startStopUse: {
        type: Function,
        default: () => () => {}
    },
    couldCheckout: {
        type: Boolean,
        default: false
    },
    couldEdit: {
        type: Boolean,
        default: false
    },
    couldSelect: {
        type: Boolean,
        default: false
    },
    checkBoxChange: {
        type: Function,
        default: () => () => {}
    },
    selectedChange: {
        type: Function,
        default: () => () => {}
    },
    couldFoldAll: {
        type: Boolean,
        default: true
    },
    foldAllFun: {
        type: Function,
        default: () => () => {}
    },
    couldUnfoldAll: {
        type: Boolean,
        default: true
    },
    dragFun: {
        type: Function,
        default: () => () => {}
    },
    dropFun: {
        type: Function,
        default: () => () => {}
    },
    dragendFun: {
        type: Function,
        default: () => () => {}
    },
    couldGrag: {
        type: Boolean,
        default: false
    },
    gragItem:{
        type:Object,
        default:() => ({})
    },
    allowDrop: {
        type: Function,
        default: () => () => {}
    },
    hoverNode: {
        type: Object,
        default: () => ({})
    }
} 

export const ButtonType =function (callBack1,callBack2,callBack3){
    return [
            {
                key:'edit',
                type:'ios-create',
                content:'编辑团队',
                callBack: callBack1,
            },
            {
                key:'add',
                type:'ios-add',
                content:'添加子团队',
                callBack: callBack2,
            },
            {
                key:'close',
                type:'ios-close',
                content:'废弃团队',
                callBack: callBack3,
            }
        ]
}